module.exports = __webpack_public_path__ + "static/media/signage-industrial-img9.d0ad8c89.jpg";